import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal as AntModal, Button, Input, message, Select } from "antd";
import { CANCEL_TYPE } from "../../../../constants";
import { IconCheckLight } from "../../../../assets/icons";
import api from "../../../../api/api";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e1e1e;
  }
  .ant-modal-close svg {
    font-size: 24px;
  }
  .ant-select {
    margin: 16px 0;
    width: 100%;
  }
  .ant-input-affix-wrapper {
    margin-bottom: 16px;
  }
  .ant-modal-footer .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
`;

const RejectReasonForCheckModal = ({
  type = "all",
  id,
  p_id,
  product_id,
  variant_id,
  open,
  handleClose,
  successCallback,
  hadnleOpenCheckModal,
}) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [cancel_type, setCancelType] = useState("");
  const [cancel_reason, setCancelReason] = useState("");

  const {t} = useTranslation();

  const handleSubmitClicked = () => {
  if (
    !cancel_type ||
    (cancel_type === CANCEL_TYPE.OTHERS && !cancel_reason)
  ) {
    return;
  }

  let reason;

  if (cancel_type === CANCEL_TYPE.OTHERS) {
    reason = {
      primary: cancel_reason,
      secondary: cancel_reason,
    };
  }else {
    reason = selectedOption?.fullData?.name;
  }

  successCallback(reason, selectedOption?.fullData?.id);

  // Reset
  setCancelType("");
  setCancelReason("");
  setSelectedOption(null);
  handleClose();
};

  const getCancelReason = () => {
    api
      .getCancelReason()
      .then((res) => setOptions(res.data || []))
      .catch((err) => message.error(err));
  };

  useEffect(() => {
    getCancelReason();
  }, []);

  const opt = [
    ...(options
      ?.filter((option) => option?.type === "ADMIN")
      .map((option) => ({
        value: option?.name.primary,
        label: option?.name?.primary,
        fullData: option,
      })) ?? []),
    {
      value: CANCEL_TYPE.OTHERS,
      label: "Others",
    },
  ];

  return (
    <Modal
      centered
      open={open}
      maskClosable={false}
      onCancel={handleClose}
      title={t('order_cancel')}
      footer={
        <Button
          type="primary"
          icon={<IconCheckLight />}
          onClick={handleSubmitClicked}
        >
          {t('submit')}
        </Button>
      }
    >
      <div>
        {t('reject_modal_text')}
      </div>
      <Select
        placeholder={t('choose_reason')}
        options={opt}
        value={cancel_type || undefined}
        onChange={(value, option) => {
          setCancelType(value);
          setSelectedOption(option);
        }}
        style={{ height: "fit-content" }}
      />
      {cancel_type === CANCEL_TYPE.OTHERS && (
        <Input.TextArea
          placeholder={t('write_reason')}
          value={cancel_reason}
          maxLength={150}
          showCount
          onChange={(e) => setCancelReason(e.target.value)}
        />
      )}
    </Modal>
  );
};

export default RejectReasonForCheckModal;
